module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","grouped":"Grouped","unGrouped":"Ungrouped","sortBy":"Sort by","noGroup":"No Group","allCompanies":"All companies"},"de":{"search":"Suchen","grouped":"Gruppiert","unGrouped":"Ungruppiert","sortBy":"Sortieren nach","noGroup":"Keine Gruppe","allCompanies":"Alle Unternehmen"}}')
  delete Component.options._Ctor
}
